export { HireAITag } from "./pages/hireaiTag";
